import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/styles/index.scss";
import SvgIcon from "./components/SvgIcon/index.vue";
import { Toast } from "vant";
import { post, get, patch, put, del } from "./utils/request";

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$del = del;

Vue.config.productionTip = false;
Vue.component("SvgIcon", SvgIcon);

Vue.use(Toast);

// 路由拦截 检验token值、
router.beforeEach((to, from, next) => {
  if (to.path === "/login" || to.path === "/studentclaims") {
    next();
  } else {
    if (localStorage.getItem("x_token")) {
      next();
    } else {
      next({ path: "/login" });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
